import {
  useJumboLayout,
  useSidebarState,
} from 'themes/jumbo/@jumbo/components/JumboLayout/hooks';
import { SIDEBAR_STYLES, SIDEBAR_VIEWS, SIDEBAR_VARIANTS } from 'themes/jumbo/@jumbo/utilities/constants';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { IconButton, Tooltip } from '@mui/material';
import { trackEvent } from 'components/Tracking';

function SidebarToggleButton() {
  const { isSidebarStyle, isSidebarOpen, isSidebarCollapsible } =
    useSidebarState();
  const { sidebarOptions, setSidebarOptions } = useJumboLayout();

  return (
    <>
      {isSidebarCollapsible() && (
        <IconButton
          edge='start'
          color='inherit'
          aria-label='open drawer'
          sx={{
            ml: isSidebarStyle(SIDEBAR_STYLES.CLIPPED_UNDER_HEADER) ? -2 : 0,
            mr: 3,
            boxShadow: 23,
          }}
          onClick={() => {
            const options = { 
              open: !sidebarOptions.open,
              view: SIDEBAR_VIEWS.FULL,
              variant: SIDEBAR_VARIANTS.PERMANENT,
            };
            trackEvent("Menu", "Sidebar", "Open");
            localStorage.setItem('userSideBarOptions', JSON.stringify(options)); 
            setSidebarOptions(options)}
          }
        >
          {isSidebarOpen() ? <Tooltip title="Hide sidebar" placement="top" arrow><MenuOpenIcon /></Tooltip> : <Tooltip title="Expand sidebar" placement="top" arrow><MenuIcon /></Tooltip>}
        </IconButton>
      )}
    </>
  );
}

export { SidebarToggleButton };
